import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AlertController, ModalController } from '@ionic/angular';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { Scene } from 'src/app/models/Scene';
import { VideoSceneAssetRelation } from 'src/app/models/scene-asset-relations/videoSceneAssetRelation';
import { AssetManagementService } from 'src/app/services/asset-management.service';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { FileService } from 'src/app/services/file.service';
import { ValidationService } from 'src/app/services/validation.service';
import { ConfirmReplaceMediaModalPage } from '../../confirm-replace-media-modal/confirm-replace-media-modal.page';

@Component({
  selector: 'app-video-asset-wizard',
  templateUrl: './video-asset-wizard.component.html',
  styleUrls: ['./video-asset-wizard.component.scss'],
})
export class VideoAssetWizardComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('assetsOnMediaManagementPage') assetsOnMediaManagementPage: MediaAsset[] = [];
  @Input('editing') editing: boolean = false;

  public addFromMediaManagementPage: boolean = false;
  public steps: any = [];

  public uploadProperties: any = {
    fileUploaded: false,
    assetIDToCopy: -1,
    fileName: "",
    isCompressed: true,
    breakConnection: false,
    addToMediaManagementPage: false
  }
  public currentStepInfo: any = {
    currentStepIndex: 0,
    currentSubStepIndex: 0,
    needHelp: false,
    addFromMediaManagementPage: this.addFromMediaManagementPage,
    uploadProperties: this.uploadProperties
  }
  public assetTypeId: number=5;
  public isFromMediaManagementPage: boolean = false;
  public assetOnMediaManagementPage: MediaAsset;

  constructor(
    private sanitizer: DomSanitizer,
    private alertController: AlertController,
    public modalController: ModalController,
    public assetTypeService: AssetTypeService,
    public validationService: ValidationService,
    public fileService: FileService
  ) {
    this.steps = [{
      index: 1,
      description: "Introduction",
      complete: false,
      active: true
    }, {
      index: 2,
      description: "Actions",
      complete: false,
      active: false
    }, {
      index: 3,
      description: "Learning Objectives",
      complete: false,
      active: false
    }];
  }

  ngOnInit() {
    if(!this.editing)
      this.setUpAssetScale(this.assetInScene.sceneAssetRelation, '1', '0.5', '0.1');

    this.assetTypeId = this.assetTypeService.getId(this.assetType);

    if(this.editing){
      var videoAsset = this.assetInScene.baseAsset as MediaAsset;
      if (videoAsset.src !="")
      this.uploadProperties.fileName = videoAsset.name;
    }

    this.assetOnMediaManagementPage = this.assetsOnMediaManagementPage.find(x => x.baseAssetId == this.assetInScene.baseAsset.baseAssetId);
    if(this.assetOnMediaManagementPage){
      this.currentStepInfo.uploadProperties.assetIDToCopy = this.assetOnMediaManagementPage.baseAssetId;
      this.isFromMediaManagementPage = true;
    }
  }

  validateVideoProperties(): boolean{
    let videoAsset = this.assetInScene.baseAsset as MediaAsset;

    if (!videoAsset.name || videoAsset.name.trim().length == 0 || this.currentStepInfo.uploadProperties.fileName=="") {
      this.goToStep(1);
      return false;
    }
    return true;
  }

  backToBrowse(){
    this.currentStepInfo.addFromMediaManagementPage=false;

  }

  saveSelectedVideo(){
    let videoAsset = this.assetInScene.baseAsset as any;
    if (Number(this.currentStepInfo.uploadProperties.assetIDToCopy) <= 0) {
      return;
    }
    let asset = this.assetsOnMediaManagementPage.find(a => a.baseAssetId == this.currentStepInfo.uploadProperties.assetIDToCopy);
    videoAsset.name = asset.name;
    videoAsset.src = asset.src;
    this.currentStepInfo.uploadProperties.fileName = asset.name;
    this.currentStepInfo.addFromMediaManagementPage=false;
    this.currentStepInfo.uploadProperties.fileUploaded = false;
    this.currentStepInfo.uploadProperties.addToMediaManagementPage = false;
    this.currentStepInfo.uploadProperties.isCompressed = false;
  }

  async closeModal() {
    const alert = await this.alertController.create({
      header: 'Are you sure?',
      message: 'Are you sure you want to leave? Any changes will not be saved.',
      cssClass: 'leave-alert quizard-alert quizard-leave-alert',
      buttons: [{
        text: 'Yes',
        cssClass: '',
        handler: () => {
          this.modalController.dismiss();
        }
      }, {
        text: 'No',
        cssClass: '',
        handler: () => {
          alert.dismiss();
        }
      }
      ]
    });
    await alert.present();
  }

  async saveMediaAsset() {

    if (this.validateVideoProperties() == false) {
      return;
    }

    let videoAsset = this.assetInScene.baseAsset as MediaAsset;
    let videoSrcResult = videoAsset.src;
    if(this.currentStepInfo.uploadProperties.fileUploaded == true){
      //UPLOADS THE FILE
      videoSrcResult = await this.uploadVideoFile();
      videoAsset.src = videoSrcResult;

      //UPDATE THE SRC ON SCENE AND ON MEDIA MANAGEMENT PAGE
      if(this.isFromMediaManagementPage && this.currentStepInfo.uploadProperties.breakConnection == false){
        this.assetOnMediaManagementPage.src = videoSrcResult;
        this.existingAssetsInScene
        .filter(x => x.baseAsset.baseAssetId == this.assetInScene.baseAsset.baseAssetId 
          && x.sceneAssetRelation.sceneAssetRelationId !== this.assetInScene.sceneAssetRelation.sceneAssetRelationId)
        .forEach(x => {
          let mediaAsset = x.baseAsset as MediaAsset;
          mediaAsset.src = videoSrcResult;
        });
      }
    }

    let data: any = {
      assetForScene: this.assetInScene,
      assetType: this.assetType,
      compress: this.currentStepInfo.uploadProperties.isCompressed,
      assetIDToCopy: this.currentStepInfo.uploadProperties.assetIDToCopy,
      fileUploaded: this.currentStepInfo.uploadProperties.fileUploaded,
      breakConnection: this.currentStepInfo.uploadProperties.breakConnection,
      addToMediaManagementPage: this.currentStepInfo.uploadProperties.addToMediaManagementPage
    }
    this.modalController.dismiss(data);
  }

  setUpAssetScale(sceneAssetRelation, x: string, y: string, z: string) {
    sceneAssetRelation.xScale = x;
    sceneAssetRelation.yScale = y;
    sceneAssetRelation.zScale = z;
    sceneAssetRelation.scale = x + ' ' + y + ' ' + z;
    sceneAssetRelation.keepAspectRatio = true;
    sceneAssetRelation.aspectRatioConstant = 0.5;
  }

  
  exitHelp() {
    this.currentStepInfo.needHelp = false;
  }

  goToHelp() {
    this.currentStepInfo.needHelp = true;
  }

  goToStep(step: number) {
    if (this.currentStepInfo.currentStepIndex == step)
      return;
    this.steps[this.currentStepInfo.currentStepIndex].complete = true;
    this.currentStepInfo.currentStepIndex = step;
    this.steps[this.currentStepInfo.currentStepIndex].active = true;
    this.steps[this.currentStepInfo.currentStepIndex].complete = false;
    this.currentStepInfo.needHelp = false;
  }

  previousStep() {
      if (this.currentStepInfo.currentStepIndex > 0)
        this.goToStep(this.currentStepInfo.currentStepIndex - 1);
  }

  nextStep(){
    this.goToStep(this.currentStepInfo.currentStepIndex +1);
  } 

  async fileFromComputerSelected(event) {
    if (event.target.files.length == 0) return;

    this.validationService.setFileType(event);
    if (!this.validationService.doesUploadedFileMatchAssetType(this.assetTypeId)) {
      this.validationService.createAlert('Wrong Media Type Uploaded.');
      return;
    } else if (!this.validationService.isFileFormatCorrect(this.assetTypeId)) {
      this.validationService.createAlert('Unsupported File Format.');
      return;
    }
    
    let isToContinue = true;
    if(this.isFromMediaManagementPage)
      isToContinue = await this.confirmBreakConnection();        
    if(!isToContinue)
      return;

    let mediaAsset = this.assetInScene.baseAsset as any;
    this.uploadProperties.fileName = String(event.target.files[0].name).substring(0, 40);
    mediaAsset.src = URL.createObjectURL(event.target.files[0]);
    mediaAsset.src = this.sanitizer.bypassSecurityTrustUrl(mediaAsset.src);
    this.uploadProperties.assetIDToCopy = -1;
    this.uploadProperties.fileUploaded = true;
    this.uploadProperties.addToMediaManagementPage = false;
  }

  uploadVideoFile(): Promise<string>{
    return new Promise<string>((resolve) => {
      let input: any = document.querySelector('#file-input');
      var videoAsset = this.assetInScene.baseAsset as MediaAsset;
      var file = input.files[0];
      var compressVideo = this.uploadProperties.isCompressed;
      
      let title = "Uploading " + videoAsset.name + " video.";
      this.fileService.batchUploadFile(file, '5a0ffb5a-475d-4307-bf05-237f82a9302d', compressVideo, "", title).then((result) =>{
        if(compressVideo)
          videoAsset.uploadStatus = 'complete';

        resolve(result);
      });
    });
  }

  confirmBreakConnection(): Promise<boolean> {
    return new Promise<boolean>(async resolve =>{
      const confirmReplaceMediaModal = await this.modalController.create({
        id: 'confirm-replace-media-modal',
        component: ConfirmReplaceMediaModalPage,
        componentProps: {        
        }
      });
  
      confirmReplaceMediaModal.onDidDismiss().then(result => {
        if (result.data && result.data.option == 'replace') {
          this.currentStepInfo.uploadProperties.breakConnection = false;
          resolve(true);
        } else if (result.data && result.data.option == 'replaceandbreak') {
          this.currentStepInfo.uploadProperties.breakConnection = true;
          resolve(true);
        }else{
          resolve(false);
        }
      });
  
      await confirmReplaceMediaModal.present();
    });
  }
}
